import type { Project } from '@/lib/projectsApi'

const HULL_TOKEN_RE = /(?:^|[^A-Z0-9])([A-Z]{1,4}[\s_-]*\d{3,7})(?=$|[^A-Z0-9])/gi

export function normalizeHullToken(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '')
}

export function extractHullCandidates(value: string): string[] {
  const values = new Set<string>()
  for (const match of value.toUpperCase().matchAll(HULL_TOKEN_RE)) {
    const normalized = normalizeHullToken(match[1])
    if (normalized) values.add(normalized)
  }
  return [...values]
}

export type NmsMatchStatus = 'matched' | 'unmatched' | 'ambiguous'

export interface NmsFileMatch {
  file: File
  relativePath: string
  hullCandidates: string[]
  matchingProjects: Project[]
  projectId: string
  status: NmsMatchStatus
}

export function matchNmsFileToProjects(file: File, projects: Project[]): NmsFileMatch {
  const relativePath = file.webkitRelativePath || file.name
  const hullCandidates = extractHullCandidates(`${relativePath}/${file.name}`)
  const candidateSet = new Set(hullCandidates)
  const matchingProjects = projects.filter(project =>
    candidateSet.has(normalizeHullToken(project.hull_number)),
  )
  return {
    file,
    relativePath,
    hullCandidates,
    matchingProjects,
    projectId: matchingProjects.length === 1 ? matchingProjects[0].id : '',
    status: matchingProjects.length === 1
      ? 'matched'
      : matchingProjects.length > 1 ? 'ambiguous' : 'unmatched',
  }
}
